import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import { classifyPaymentValidationError } from '@src/domains/payments';
import { clearPaymentErrors, paymentErrorsSelector } from '@src/features/payments/store/payment';

export const usePaymentErrors = () => {
  const dispatch = useAppDispatch();
  const errors = useAppSelector(paymentErrorsSelector);

  const flags = useMemo(() => classifyPaymentValidationError(errors), [errors]);
  const clear = useCallback(() => dispatch(clearPaymentErrors()), [dispatch]);

  return { ...flags, errors, clear };
};
